import React, { useEffect, useState, useContext } from 'react';
import _ from 'underscore';
import { Button, Icon, Tooltip, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListContainer, HeaderText } from '../../../containers/SidebarMenu/styles';
import { TickIcon } from '../../../images/svgIcons';
import DeleteTemplateModal from '../../Modals/DeleteTemplateModal';
import Loader from '../../Loader';
import {
  getTemplateByGroup,
  translateTemplate,
} from '../../../utils/services/shortMessageTemplateAPI';
import { ShortMsgTextContext } from '../../../context/shortMessageContext';
import { SHORT_MESSAGE_TRANSLATE_TAB } from './translationValues';
/* This component used to translate messages
  Child Components: 
    * DeleteTemplateModal
*/
const NAMESPACES = ['SHORT_MESSAGE_TRANSLATE_TAB'];
const TranslateMessages = props => {
  const { t } = useTranslation(NAMESPACES);
  const { allLanguages, groupId, language, templateId } = props;
  const { callLength, whatsappLength, messageLength } = useContext(ShortMsgTextContext);
  const [loading, setLoading] = useState(true);
  const [availableLang, setAvailableLang] = useState([]);
  const [moreLang, setMoreLang] = useState([]);
  const [targetToDelete, setTargetToDelete] = useState({});
  const [modalVisible, toggleModal] = useState(false);
  const [loaderIndex, setIndex] = useState(-1);
  let history = useHistory();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [groupId]);

  const fetchData = async () => {
    let availableLang = [];
    let moreLang = [];
    if (groupId) {
      let response = await getTemplateByGroup(groupId);
      if (response?.data) {
        response = response.data;
        let selectedIds = _.pluck(response, 'language');
        for (const data of allLanguages) {
          if (selectedIds.includes(data.code)) {
            const template = response.find(a => a.language === data.code);
            data.id = template.id;
            data.templateName = template.name;
            availableLang.push(data);
          } else {
            moreLang.push(data);
          }
        }
      }
    } else {
      moreLang = allLanguages;
    }
    setAvailableLang(availableLang);
    setMoreLang(moreLang);
    setLoading(false);
  };

  const onSelect = async value => {
    history.push(`/shortMessageDesign/${value.id}`);
  };

  const addMoreLang = async (data, index) => {
    let response;
    const payload = { id: templateId, language: data.code };
    setIndex(index);
    response = await translateTemplate(payload);

    if (response && response.statusCode === 1617) {
      if (typeof response === 'object' && response.message) {
        message.success(
          t(
            SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_TRANSLATED_SUCCESS_MESSAGE.key,
            SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_TRANSLATED_SUCCESS_MESSAGE.value,
          ) +
            ' ' +
            `${data.name}. ${response.message}`,
        );
      } else {
        message.success(
          t(
            SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_TRANSLATED_SUCCESS_MESSAGE.key,
            SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_TRANSLATED_SUCCESS_MESSAGE.value,
          ) +
            ' ' +
            data.name,
        );
      }
      setIndex(-1);
      fetchData();
    } else {
      setIndex(-1);
    }
  };

  const onDelete = data => {
    let newData = { ...data };
    newData.name = newData.templateName;
    setTargetToDelete(newData);
    toggleModal(true);
  };

  const renderAvailableLanguage = () => {
    return (
      <ListContainer>
        {availableLang?.length > 0 && (
          <ul>
            {availableLang.map(data => (
              <li key={data.code} value={data.code} onClick={() => onSelect(data)}>
                <span>{data.name}</span>
                <span
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  {language === data.code ? (
                    <TickIcon />
                  ) : (
                    <Tooltip
                      title={t(
                        SHORT_MESSAGE_TRANSLATE_TAB.DELETE_TEMPLATE_LANGUAGE_BUTTON.key,
                        SHORT_MESSAGE_TRANSLATE_TAB.DELETE_TEMPLATE_LANGUAGE_BUTTON.value,
                      )}
                    >
                      <Icon
                        onClick={() => onDelete(data)}
                        type="delete"
                        style={{ fontSize: '20px' }}
                      />
                    </Tooltip>
                  )}
                </span>
              </li>
            ))}
          </ul>
        )}
      </ListContainer>
    );
  };

  const renderMoreLanguages = () => {
    return (
      <ListContainer noHover={true}>
        <ul>
          {moreLang.map((data, index) => (
            <li key={data.code} value={data.code}>
              <span>{data.name}</span>
              <Button
                icon="plus"
                disabled={loaderIndex > -1}
                loading={loaderIndex === index}
                onClick={() => addMoreLang(data, index)}
              >
                {t(
                  SHORT_MESSAGE_TRANSLATE_TAB.ADD_TEMPLATE_LANGUAGE_BUTTON.key,
                  SHORT_MESSAGE_TRANSLATE_TAB.ADD_TEMPLATE_LANGUAGE_BUTTON.value,
                )}
              </Button>
            </li>
          ))}
        </ul>
      </ListContainer>
    );
  };

  return (
    <div style={{ color: 'white' }}>
      {loading ? (
        <Loader />
      ) : (
        <>
          {callLength === 0 && whatsappLength === 0 && messageLength === 0 ? (
            <HeaderText>
              {t(
                SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_LANG_NOT_AVAILABLE.key,
                SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATES_LANG_NOT_AVAILABLE.value,
              )}
            </HeaderText>
          ) : (
            <>
              <HeaderText>
                {t(
                  SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATE_AVAILABLE_IN_LANGUAGES.key,
                  SHORT_MESSAGE_TRANSLATE_TAB.TEMPLATE_AVAILABLE_IN_LANGUAGES.value,
                )}
              </HeaderText>
              {renderAvailableLanguage()}
              {moreLang?.length > 0 && (
                <>
                  <HeaderText>
                    {t(
                      SHORT_MESSAGE_TRANSLATE_TAB.ALSO_AVAILABLE_LANGUAGES.key,
                      SHORT_MESSAGE_TRANSLATE_TAB.ALSO_AVAILABLE_LANGUAGES.value,
                    )}
                  </HeaderText>
                  {renderMoreLanguages()}
                </>
              )}
            </>
          )}
          {modalVisible && (
            <DeleteTemplateModal
              visible={modalVisible}
              isMailTemplate={false}
              isShortMessageTemplate={true}
              onCancel={() => toggleModal(false)}
              targetTemplate={targetToDelete}
              categoryType="template"
              onSucess={() => {
                toggleModal(false);
                fetchData();
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default TranslateMessages;
